import HousePricesTrends from 'components/modules/housePricesDetail/components/housePricesTrends';

export interface Location {
  locationId: number;
  locationType: string;
}

function PropertyChartHousePrices({ locationId, locationType }: Location) {
  return (
    <HousePricesTrends id={locationId} type={locationType} />
  );
}

export default PropertyChartHousePrices;
